<script setup>
    import { ref, onMounted, computed } from 'vue';

    const time = ref({ hours: 0, minutes: 0, seconds: 0 });
    const rotation = ref({ hours: 0, minutes: 0, seconds: 0 });
    let lastMinute = 0;

    function updateTime(moment) {
        rotation.value.seconds += 6
        rotation.value.minutes += 0.1
        time.value = {
            hours: moment.getHours(),
            minutes: moment.getMinutes(),
            seconds: moment.getSeconds()
        }

        if (time.value.minutes !== lastMinute) {
            rotation.value.hours += 0.5;
            lastMinute = time.value.minutes;
        }

        setTimeout(() => updateTime(new Date()), 1000 - new Date().getMilliseconds());
    }

    onMounted(() => {
        const now = new Date();
        const [h, m, s] = [now.getHours(), now.getMinutes(), now.getSeconds()];
        rotation.value = {
            hours: (h * 30) + (m * 0.5),
            minutes: (m * 6) + (s * 0.1),
            seconds: s * 6
        }
        lastMinute = m;
        updateTime(new Date());
    });

    const hours = computed(() => {
        return { transform: `translate3d(-50%, 0, 0) rotate(${rotation.value.hours}deg)` }
    });
    const minutes = computed(() => {
        return { transform: `translate3d(-50%, 0, 0) rotate(${rotation.value.minutes}deg)` }
    });
    const seconds = computed(() => {
        return { transform: `translate3d(-50%, 0, 0) rotate(${rotation.value.seconds}deg)` }
    });

</script>

<template>
    <div class="card my-2 mx-2 py-3 px-3 flex align-items-center">
            <figure class="analog-clock" style="height: 100px; width: 100px;">
                <figcaption class="analog-clock__face">
                    <span v-for="n in 60"
                        :key="n"
                        class="analog-clock__notch"
                        :class="{ '-long': !(n % 5) }"
                        :style="{ transform: `rotate(${n * 6}deg)` }">
                    </span>
                </figcaption>

                <span class="analog-clock__hand -seconds" :style="seconds"></span>
                <span class="analog-clock__hand -minutes" :style="minutes"></span>
                <span class="analog-clock__hand -hours" :style="hours"></span>
            </figure>
    </div>
</template>

<style lang="scss" scoped>
.analog-clock {
    margin: 0 0 0 0;
    border-radius: 100%;
    background-color: var(--surface-card);
    filter: drop-shadow(0 0.125rem 0.3rem var(--text-color, 0.1));

    &::after {
        top: 50%;
        left: 50%;
        content: '';
        width: 2.5%;
        height: 2.5%;
        border-radius: 100%;
        background-color: var(--text-color);
    }

    &__face {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    &__notch {
        transform-origin: 50% 100%;
        position: absolute;
        width: 1px;
        height: 49%;
        bottom: 50%;
        left: 50%;

        &::after {
            content: '';
            width: 100%;
            height: 2.5%;
            position: absolute;
            top: 0;
            left: 0;
            background-color: var(--text-color);
        }

        &.-long::after {
            width: 2px;
            height: 7.5%;
        }
    }

    &__hand {
        transform-origin: 50% 100%;
        background-color: #7392a0;
        position: absolute;
        width: 2px;
        height: 40%;
        bottom: 50%;
        left: 50%;
        border-radius: 2px;

        &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            height: 10%;
            background-color: inherit;
            backface-visibility: hidden;
        }

        &.-hours {
            height: 30%;
            width: 2px;
            border-radius: 3px;
        }

        &.-minutes {
            height: 40%;
            width: 2px;
            border-radius: 3px;
            background-color: var(--blue-400);
        }

        &.-seconds {
            width: 2px;
            height: 45%;
            border-radius: 0;
            background-color: #edbec5;
            &::after {
                height: 12.5%;
            }
        }
    }
}

</style>